import { dataFolderTimeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderTimeSolid = /*#__PURE__*/createIcon(dataFolderTimeSolid)
export default IconFolderTimeSolid
